export default {
  // ── ナビゲーション ─────────────────────────────────────────────────
  'landing.nav.features': '製品機能',
  'landing.nav.architecture': 'アーキテクチャ',
  'landing.nav.scenarios': '活用シーン',
  'landing.nav.ecosystem': 'エコシステム',
  'landing.nav.cases': '導入事例',
  'landing.nav.pricing': '料金',
  'landing.nav.login': 'ログイン',
  'landing.nav.freeTrial': '無料トライアル',

  // ── 統計 ──────────────────────────────────────────────────────────
  'landing.stats.efficiency.label': '平均効率向上',
  'landing.stats.efficiency.desc': '従来の手動作業との比較',
  'landing.stats.accuracy.label': 'ナレッジ検索精度',
  'landing.stats.accuracy.desc': '企業専用ナレッジベースQ&A',
  'landing.stats.customers.label': '導入企業数',
  'landing.stats.customers.desc': '10以上の業界をカバー',

  // ── ヒーロー ──────────────────────────────────────────────────────
  'landing.hero.badge': 'エンタープライズAIコラボレーションプラットフォーム',
  'landing.hero.title.line1': 'すべてのチームに',
  'landing.hero.title.line2': '専属の',
  'landing.hero.title.highlight': 'AI コラボレーションブレイン',
  'landing.hero.subtitle': 'ナレッジベース、文書処理、インテリジェントQ&Aを統合し、企業チームの繰り返し作業をなくし、知識の流通を加速します。',
  'landing.hero.stat.customers': '企業クライアント',
  'landing.hero.stat.uptime': 'サービス稼働率',
  'landing.hero.stat.efficiency': '効率向上',
  'landing.hero.cta.start': '無料トライアル',
  'landing.hero.cta.demo': 'デモを予約',
  'landing.hero.trust.appstore': '4.9点 · App Store レビュー',
  'landing.hero.trust.noCard': 'クレジットカード不要',
  'landing.hero.badge.todayDocs': '本日処理した文書',
  'landing.hero.badge.increase': '↑ 12% 前日比',
  'landing.hero.badge.contractDone': '契約書自動審査完了',
  'landing.hero.badge.timeSaved': 'たった今 · 2.5時間節約',
  'landing.hero.trusted': '業界トップ企業に信頼されています',
  'landing.hero.preview.placeholder': '製品スクリーンショット / デモ動画',
  'landing.hero.preview.hint': 'img src を差し替えると実際のコンテンツが表示されます',

  // ── 機能 ──────────────────────────────────────────────────────────
  'landing.features.badge': 'コア機能',
  'landing.features.title': '企業AIの限界を再定義する',
  'landing.features.subtitle': '6つのコア機能モジュールで企業AI化変革の全シーンをカバー。すぐに使えて、素早く統合できます',
  'landing.features.learnMore': '詳細を見る →',

  'landing.feature.knowledge.title': 'インテリジェントナレッジアシスタント',
  'landing.feature.knowledge.desc': '企業専用ナレッジベースからAIアシスタントを構築。正確なQ&A、瞬時の応答、情報サイロを解消します。',
  'landing.feature.knowledge.tag1': 'RAG検索',
  'landing.feature.knowledge.tag2': 'マルチターン対話',
  'landing.feature.knowledge.tag3': '出典引用',

  'landing.feature.document.title': 'インテリジェント文書処理',
  'landing.feature.document.desc': 'PDF、Word、Excelなどの文書を自動解析し、構造化情報を抽出。バッチ処理効率を10倍に向上します。',
  'landing.feature.document.tag1': 'OCR認識',
  'landing.feature.document.tag2': '自動要約',
  'landing.feature.document.tag3': '構造抽出',

  'landing.feature.workflow.title': 'ワークフロー自動化',
  'landing.feature.workflow.desc': '既存の企業システムと連携し、AI駆動の自動化ワークフローを構築。繰り返し作業を削減し、チームの創造性を解放します。',
  'landing.feature.workflow.tag1': 'ワークフロー編成',
  'landing.feature.workflow.tag2': 'システム統合',
  'landing.feature.workflow.tag3': 'スケジュールタスク',

  'landing.feature.security.title': 'エンタープライズグレードのセキュリティ',
  'landing.feature.security.desc': 'プライベート展開対応、データは社内に留まり、金融・医療・行政などの業界コンプライアンス要件を満たします。',
  'landing.feature.security.tag1': 'プライベート展開',
  'landing.feature.security.tag2': 'データマスキング',
  'landing.feature.security.tag3': '監査ログ',

  'landing.feature.model.title': 'マルチモデル管理',
  'landing.feature.model.desc': 'GPT-4、Claude、文心、通義などの主要LLMに統一アクセス。インテリジェントルーティングとオンデマンド切り替えをサポート。',
  'landing.feature.model.tag1': 'モデルルーティング',
  'landing.feature.model.tag2': 'コスト最適化',
  'landing.feature.model.tag3': 'A/Bテスト',

  'landing.feature.analytics.title': 'データ分析・インサイト',
  'landing.feature.analytics.desc': '自然言語でデータベースを照会し、一文でチャートレポートを生成。誰もがデータアナリストになれます。',
  'landing.feature.analytics.tag1': 'NL2SQL',
  'landing.feature.analytics.tag2': 'ビジュアライゼーション',
  'landing.feature.analytics.tag3': 'レポート生成',

  // ── アーキテクチャ ─────────────────────────────────────────────────
  'landing.arch.badge': 'プラットフォームアーキテクチャ',
  'landing.arch.title': '4層アーキテクチャ、堅牢で信頼性が高い',
  'landing.arch.subtitle': '各レイヤーをクリックして詳細な機能説明を確認し、完全な技術スタックを理解する',
  'landing.arch.integrations': '企業システム · DingTalk · Lark · WeChat · カスタムAPI',

  'landing.arch.app.label': 'アプリケーション層',
  'landing.arch.app.sublabel': 'Application Layer',
  'landing.arch.app.item.0': 'ナレッジアシスタント',
  'landing.arch.app.item.1': '文書インテリジェンス',
  'landing.arch.app.item.2': 'プロセスボット',
  'landing.arch.app.item.3': 'データ分析',
  'landing.arch.app.desc': 'ビジネス向けAIアプリ、迅速なカスタム展開が可能。Web、モバイル、APIの3つのアクセス方式をサポート。',

  'landing.arch.platform.label': 'プラットフォーム層',
  'landing.arch.platform.sublabel': 'Platform Layer',
  'landing.arch.platform.item.0': 'プロンプト管理',
  'landing.arch.platform.item.1': '対話編成',
  'landing.arch.platform.item.2': 'ワークフローエンジン',
  'landing.arch.platform.item.3': 'アクセス制御',
  'landing.arch.platform.desc': 'コアプラットフォーム機能：ローコードAIアプリビルダー、モデルルーティングとコスト最適化、エンドツーエンド監視。',

  'landing.arch.model.label': 'モデル層',
  'landing.arch.model.sublabel': 'Model Layer',
  'landing.arch.model.item.0': 'GPT-4o',
  'landing.arch.model.item.1': 'Claude 3.5',
  'landing.arch.model.item.2': '文心一言',
  'landing.arch.model.item.3': '通義千問',
  'landing.arch.model.desc': '主流LLMへの統一アクセス、オープンソースモデルのプライベート展開サポート、推論コストを削減するインテリジェントルーティング。',

  'landing.arch.data.label': 'データ層',
  'landing.arch.data.sublabel': 'Data Layer',
  'landing.arch.data.item.0': 'ベクターデータベース',
  'landing.arch.data.item.1': '企業ナレッジベース',
  'landing.arch.data.item.2': '構造化データ',
  'landing.arch.data.item.3': 'ファイルストレージ',
  'landing.arch.data.desc': '企業データの統一ガバナンス、ベクトルインデックスによる高速検索、AIの回答がトレーサブルで監査可能かつ安全であることを保証。',

  // ── 活用シーン ────────────────────────────────────────────────────
  'landing.scenarios.badge': '活用シーン',
  'landing.scenarios.title': '企業AI化の全シーンをカバー',
  'landing.scenarios.subtitle': '個人の生産性ツールからフルプロセス自動化まで、あらゆる規模の企業のニーズに対応',
  'landing.scenarios.viewSolution': 'ソリューション全体を見る →',
  'landing.scenarios.coreCaps': 'コア機能',
  'landing.scenarios.implemented': '200社以上がこのシーンで導入済み',
  'landing.scenarios.caseLib': '事例ライブラリ →',

  'landing.scenario.office.tab': 'エンタープライズAIオフィス',
  'landing.scenario.office.title': 'すべての従業員にAIアシスタントを',
  'landing.scenario.office.desc': 'スマート議事録、メール下書き、レポート生成、スケジュール管理――煩雑な作業を自動化し、チームが高付加価値な仕事に集中できるようにします。',
  'landing.scenario.office.metric.0.label': '繰り返し作業の削減',
  'landing.scenario.office.metric.0.value': '68%',
  'landing.scenario.office.metric.1.label': '文書処理速度',
  'landing.scenario.office.metric.1.value': '10倍',
  'landing.scenario.office.metric.2.label': '従業員満足度',
  'landing.scenario.office.metric.2.value': '94%',
  'landing.scenario.office.feature.0': 'スマート会議アシスタント',
  'landing.scenario.office.feature.1': 'メール自動返信',
  'landing.scenario.office.feature.2': 'ワンクリックレポート生成',
  'landing.scenario.office.feature.3': 'プレゼンコンテンツアシスタント',
  'landing.scenario.office.feature.4': '多言語翻訳',
  'landing.scenario.office.feature.5': 'インテリジェントスケジューリング',

  'landing.scenario.knowledge.tab': 'ナレッジアシスタント',
  'landing.scenario.knowledge.title': '企業のナレッジを活性化する',
  'landing.scenario.knowledge.desc': '製品マニュアル、規定、業界文献を取り込み、専用のQ&Aシステムを構築。新入社員は1日で習熟、カスタマーサービスの応答速度は5倍に。',
  'landing.scenario.knowledge.metric.0.label': 'ナレッジ検索精度',
  'landing.scenario.knowledge.metric.0.value': '97%',
  'landing.scenario.knowledge.metric.1.label': '新入社員トレーニング速度',
  'landing.scenario.knowledge.metric.1.value': '75%向上',
  'landing.scenario.knowledge.metric.2.label': 'カスタマーサービス応答速度',
  'landing.scenario.knowledge.metric.2.value': '5倍',
  'landing.scenario.knowledge.feature.0': 'マルチフォーマット文書インポート',
  'landing.scenario.knowledge.feature.1': 'インテリジェントベクトル検索',
  'landing.scenario.knowledge.feature.2': '出典引用',
  'landing.scenario.knowledge.feature.3': '階層型権限管理',
  'landing.scenario.knowledge.feature.4': 'ナレッジグラフ',
  'landing.scenario.knowledge.feature.5': '継続的学習・更新',

  'landing.scenario.document.tab': '文書インテリジェンス',
  'landing.scenario.document.title': '文書処理効率を飛躍的に向上',
  'landing.scenario.document.desc': '契約審査、財務諸表分析、法的文書の解釈――AIが数秒で、かつて数時間かかっていた専門的な文書処理を完了します。',
  'landing.scenario.document.metric.0.label': '契約審査速度',
  'landing.scenario.document.metric.0.value': '20倍',
  'landing.scenario.document.metric.1.label': '情報抽出精度',
  'landing.scenario.document.metric.1.value': '98.5%',
  'landing.scenario.document.metric.2.label': '年間コスト削減',
  'landing.scenario.document.metric.2.value': '500万円+',
  'landing.scenario.document.feature.0': 'PDF/Word 深層解析',
  'landing.scenario.document.feature.1': '契約重要条項抽出',
  'landing.scenario.document.feature.2': '財務レポートサマリー',
  'landing.scenario.document.feature.3': 'マルチ文書比較分析',
  'landing.scenario.document.feature.4': 'リスク自動注釈',
  'landing.scenario.document.feature.5': 'バッチ処理',

  'landing.scenario.workflow.tab': 'プロセス自動化',
  'landing.scenario.workflow.title': 'あらゆるビジネスプロセスを加速',
  'landing.scenario.workflow.desc': 'ビジュアルワークフロー編成で、承認・レポート・データ同期などの繰り返し作業をAIに委託。DingTalk、Lark、SAP、Salesforceなどと連携。',
  'landing.scenario.workflow.metric.0.label': 'プロセス自動化率',
  'landing.scenario.workflow.metric.0.value': '85%',
  'landing.scenario.workflow.metric.1.label': 'エラー率削減',
  'landing.scenario.workflow.metric.1.value': '92%',
  'landing.scenario.workflow.metric.2.label': 'ROI回収期間',
  'landing.scenario.workflow.metric.2.value': '3ヶ月',
  'landing.scenario.workflow.feature.0': 'ビジュアルワークフローデザイナー',
  'landing.scenario.workflow.feature.1': 'スマート条件分岐',
  'landing.scenario.workflow.feature.2': 'マルチシステムデータ同期',
  'landing.scenario.workflow.feature.3': '異常自動アラート',
  'landing.scenario.workflow.feature.4': 'ワークフローバージョン管理',
  'landing.scenario.workflow.feature.5': 'オープンAPI統合',

  // ── エコシステム ───────────────────────────────────────────────────
  'landing.ecosystem.badge': 'エコシステム',
  'landing.ecosystem.title': 'デジタルエンタープライズと接続する',
  'landing.ecosystem.subtitle': '200以上の企業システムコネクターをプリセット。すぐに使えて、任意のプラットフォームへのカスタムAPI接続もサポート',
  'landing.ecosystem.enterpriseSystems': '企業システム統合',
  'landing.ecosystem.llmSupport': '大規模言語モデルサポート',

  'landing.integration.category.collab': 'コラボレーション',
  'landing.integration.category.database': 'データベース',
  'landing.integration.category.search': '検索',
  'landing.integration.category.storage': 'ストレージ',
  'landing.integration.category.mq': 'メッセージキュー',

  'landing.api.rest.desc': '標準OpenAPI仕様',
  'landing.api.webhook.desc': 'リアルタイムイベントプッシュ',
  'landing.api.sdk.desc': 'Python / Node / Java',
  'landing.api.security.label': 'エンタープライズセキュリティ',
  'landing.api.security.desc': 'SSO / OAuth2 / SAML',

  // ── 導入事例 ──────────────────────────────────────────────────────
  'landing.cases.badge': '導入事例',
  'landing.cases.title': '500社以上が選んだプラットフォーム',
  'landing.cases.subtitle': '金融、製造、小売、行政などの業界からの実際の導入事例',
  'landing.cases.industryLabel': '{industry}業界',
  'landing.cases.coveredIndustries': '対応業界',

  'landing.case.bank.company': '大手株式制商業銀行',
  'landing.case.bank.industry': '金融',
  'landing.case.bank.quote': '以前は3人のベテランコンプライアンス担当者が1週間かかっていた文書を、今やAIが2時間で初審を完了できます。しかも品質が高い。',
  'landing.case.bank.author': 'コンプライアンス最高責任者',
  'landing.case.bank.result.0.metric': '審査効率',
  'landing.case.bank.result.0.value': '15倍',
  'landing.case.bank.result.1.metric': 'コンプライアンスリスク削減',
  'landing.case.bank.result.1.value': '78%',
  'landing.case.bank.result.2.metric': '年間人件費削減',
  'landing.case.bank.result.2.value': '5,300万円',

  'landing.case.mfg.company': '大手製造グループ',
  'landing.case.mfg.industry': '製造',
  'landing.case.mfg.quote': '20年分の工程ナレッジをすべてデジタル化しました。今では新入社員が3週間で即戦力になれます。以前では考えられなかったことです。',
  'landing.case.mfg.author': 'グループCIO',
  'landing.case.mfg.result.0.metric': '新入社員研修期間',
  'landing.case.mfg.result.0.value': '80%短縮',
  'landing.case.mfg.result.1.metric': '技術的問題の対応時間',
  'landing.case.mfg.result.1.value': '12倍改善',
  'landing.case.mfg.result.2.metric': '年間研修コスト削減',
  'landing.case.mfg.result.2.value': '7,200万円',

  'landing.case.ecom.company': '大手ECプラットフォーム',
  'landing.case.ecom.industry': 'EC',
  'landing.case.ecom.quote': 'セール期間中のカスタマーサービスのピーク接続数が50万件を超えましたが、AIがすべての負荷を処理し、顧客満足度はむしろ向上しました。',
  'landing.case.ecom.author': 'カスタマーサービス責任者',
  'landing.case.ecom.result.0.metric': '自動解決率',
  'landing.case.ecom.result.0.value': '83%',
  'landing.case.ecom.result.1.metric': 'サポートスタッフ削減',
  'landing.case.ecom.result.1.value': '60%',
  'landing.case.ecom.result.2.metric': '顧客NPS',
  'landing.case.ecom.result.2.value': '+42',

  'landing.industry.0': '金融・銀行',
  'landing.industry.1': '製造業',
  'landing.industry.2': '小売・EC',
  'landing.industry.3': 'ヘルスケア',
  'landing.industry.4': '行政サービス',
  'landing.industry.5': '教育・研修',
  'landing.industry.6': '不動産',
  'landing.industry.7': '物流・輸送',
  'landing.industry.8': '法律サービス',
  'landing.industry.9': 'エネルギー・化学',

  // ── セキュリティ ───────────────────────────────────────────────────
  'landing.security.title': '信頼できるエンタープライズグレードのセキュリティ',
  'landing.security.subtitle': '国際的なセキュリティ認証取得済み、プライベート展開対応――データは常にあなたの手元に',
  'landing.security.footer': 'プライベート展開オプション · データを完全に管理 · ',
  'landing.security.whitepaper': 'セキュリティホワイトペーパーを見る →',

  'landing.security.encrypt.title': 'エンドツーエンドデータ暗号化',
  'landing.security.encrypt.badge': 'ISO 27001 認定',
  'landing.security.encrypt.desc': '転送中・保存中のデータに銀行グレードの暗号化を適用し、定期的なセキュリティ監査で企業データの安全を確保します。',
  'landing.security.access.title': 'きめ細かいアクセス制御',
  'landing.security.access.badge': 'SOC 2 Type II',
  'landing.security.access.desc': '3レベルの権限システムで、SSO / OAuth2 / SAMLを完全サポート。企業のコンプライアンス審査要件を満たします。',
  'landing.security.compliance.title': 'コンプライアンス保証',
  'landing.security.compliance.badge': 'GDPR準拠',
  'landing.security.compliance.desc': 'プライベート展開対応でデータは完全に管理下に置かれ、国内外のプライバシー規制に準拠しています。',

  // ── 料金 ──────────────────────────────────────────────────────────
  'landing.pricing.badge': 'プランと料金',
  'landing.pricing.title': '組織に最適なプランを選ぶ',
  'landing.pricing.subtitle': '無料トライアルからプライベート展開まで、あらゆる規模の企業のニーズに対応',
  'landing.pricing.footer': '全プランに14日間無料トライアル · クレジットカード不要 · いつでもキャンセル可能',

  'landing.pricing.starter.name': 'スターター',
  'landing.pricing.starter.price': '無料',
  'landing.pricing.starter.priceNote': '永久無料',
  'landing.pricing.starter.desc': 'AIコラボレーション機能を試すのに最適',
  'landing.pricing.starter.cta': '始める',
  'landing.pricing.starter.feature.0': '基本ナレッジアシスタント',
  'landing.pricing.starter.feature.1': '文書アップロード 20件',
  'landing.pricing.starter.feature.2': '5人チーム',
  'landing.pricing.starter.feature.3': '標準サポート',
  'landing.pricing.starter.feature.4': 'コミュニティ更新',

  'landing.pricing.pro.name': 'プロフェッショナル',
  'landing.pricing.pro.price': 'お問い合わせ',
  'landing.pricing.pro.priceNote': 'カスタム料金',
  'landing.pricing.pro.desc': 'SMEチーム向け、AI機能をフルに解放',
  'landing.pricing.pro.cta': '営業に連絡',
  'landing.pricing.pro.badge': '最も人気',
  'landing.pricing.pro.feature.0': 'スターターの全機能',
  'landing.pricing.pro.feature.1': '無制限文書アップロード',
  'landing.pricing.pro.feature.2': '無制限ユーザー',
  'landing.pricing.pro.feature.3': 'APIアクセス',
  'landing.pricing.pro.feature.4': '高度なデータ分析',
  'landing.pricing.pro.feature.5': '専任カスタマーサクセスマネージャー',

  'landing.pricing.enterprise.name': 'エンタープライズ',
  'landing.pricing.enterprise.price': 'カスタム見積もり',
  'landing.pricing.enterprise.priceNote': 'プライベート · カスタム',
  'landing.pricing.enterprise.desc': '大企業向け、完全に管理されたプライベート展開',
  'landing.pricing.enterprise.cta': '見積もりを取得',
  'landing.pricing.enterprise.feature.0': 'プロフェッショナルの全機能',
  'landing.pricing.enterprise.feature.1': 'プライベート展開',
  'landing.pricing.enterprise.feature.2': '専任実装コンサルタント',
  'landing.pricing.enterprise.feature.3': 'SLA 99.9% 保証',
  'landing.pricing.enterprise.feature.4': 'カスタムシステム統合',
  'landing.pricing.enterprise.feature.5': 'セキュリティ監査・コンプライアンス',

  // ── CTA ───────────────────────────────────────────────────────────
  'landing.cta.title1': 'AIで',
  'landing.cta.titleHighlight': ' あなたの企業を ',
  'landing.cta.title2': '変革する準備はできていますか？',
  'landing.cta.subtitle': '500社以上のリーディング企業と共に、{title}でAI効率の新しいフロンティアを解き放ちましょう。14日間無料体験、専任オンボーディングコンサルタント付き。',
  'landing.cta.emailPlaceholder': 'ビジネスメールアドレスを入力',
  'landing.cta.startFree': '無料で始める',
  'landing.cta.perk.0': '14日間無料、クレジットカード不要',
  'landing.cta.perk.1': '専任1対1実装コンサルタント',
  'landing.cta.perk.2': 'データセキュリティ、プライベート展開可能',
  'landing.cta.perk.3': '24時間365日テクニカルサポート',

  // ── フッター ──────────────────────────────────────────────────────
  'landing.footer.brand.desc': '企業のためのAIインテリジェントアプリケーション層プラットフォームを構築し、AIでビジネス成長を真に実現します。',
  'landing.footer.product': '製品',
  'landing.footer.solution': 'ソリューション',
  'landing.footer.resource': 'リソース',
  'landing.footer.contact': 'お問い合わせ',
  'landing.footer.copyright': '全著作権所有。',

  'landing.footer.product.0': 'ナレッジアシスタント',
  'landing.footer.product.1': '文書インテリジェンス',
  'landing.footer.product.2': 'プロセス自動化',
  'landing.footer.product.3': 'データ分析',
  'landing.footer.product.4': 'エンタープライズAPI',

  'landing.footer.solution.0': '金融業界',
  'landing.footer.solution.1': '製造業',
  'landing.footer.solution.2': '小売・EC',
  'landing.footer.solution.3': 'ヘルスケア',
  'landing.footer.solution.4': '行政サービス',

  'landing.footer.resource.0': '開発者ドキュメント',
  'landing.footer.resource.1': 'ブログ',
  'landing.footer.resource.2': '導入事例',
  'landing.footer.resource.3': 'ビデオチュートリアル',
  'landing.footer.resource.4': 'テックコミュニティ',

  'landing.footer.contact.0.label': 'ビジネスパートナーシップ',
  'landing.footer.contact.0.val': 'sales@example.ai',
  'landing.footer.contact.1.label': 'テクニカルサポート',
  'landing.footer.contact.1.val': 'support@example.ai',
  'landing.footer.contact.2.label': 'メディア問い合わせ',
  'landing.footer.contact.2.val': 'pr@example.ai',
  'landing.footer.contact.3.label': 'パートナーホットライン',
  'landing.footer.contact.3.val': '+81-3-8888-8888',

  'landing.footer.legal.0': 'プライバシーポリシー',
  'landing.footer.legal.1': '利用規約',
  'landing.footer.legal.2': 'セキュリティホワイトペーパー',
};
